<template>
  <div>
    <!-- 指纹验证弹窗 -->
    <el-dialog :title="'指纹验证'" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false"
      @closed="handleDialogClose" center>
      <div class="content">
        <div class="collection" v-if="!isConnecting">
          <img src="@/assets/img/fingerprint.svg" alt="">
          <div class="text">{{ text }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      logs: [],
      isConnecting: false,//是否正在连接
      isGettingFeature: false,//是否正在获取特征
      handle: null,//指纹设备句柄
      lastStateCode: -1,//上一次采集状态码
      text: '请将手指放在识别器上进行指纹验证',
      feature: '',//指纹特征
    };
  },
  methods: {
    // 打开弹窗时初始化
    openDialog() {
      this.dialogVisible = true;
      this.startGetFeature()
      this.text = '请将手指放在识别器上进行指纹验证'
    },
    // 弹窗关闭时清理
    handleDialogClose() {
    },
    addLog(message, type = 'info') {
      const now = new Date()
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`
      this.logs.push({
        time: timeStr,
        message: message,
        type: type
      })
      setTimeout(() => {
        const consoleEl = document.querySelector('.console')
        if (consoleEl) {
          consoleEl.scrollTop = consoleEl.scrollHeight
        }
      }, 10)
    },
    clearLog() {
      this.logs = []
    },
    startGetFeature() {
      this.addLog('指纹服务开始连接...', 'info')
      this.isConnecting = true
      Fp.connect(() => {
        this.addLog('指纹服务连接成功', 'success')
        Fp.setDeviceType(Fp.SERIAL_DEVICE, () => {
          this.addLog('开始打开设备...', 'info')
          Fp.openDevice(-1, (returnObj) => {
            this.handle = returnObj.handle
            if (this.handle > 0) {
              this.addLog('设备打开成功', 'success')
              this.isConnecting = false
              this.isGettingFeature = true
              this.getFeature(this.handle)
            } else {
              this.addLog('设备打开失败', 'error')
              this.text = '指纹设备打开失败'
              this.isConnecting = false
            }
          })
        })
      })
    },
    stopGetFeature() {
      this.isGettingFeature = false
      this.addLog('获取特征任务已取消', 'warning')
      if (this.handle && this.handle > 0) {
        Fp.closeDevice(this.handle, (returnObj) => {
          if (returnObj.retCode == Fp.RT_SUCCESS) {
            this.addLog('设备已关闭', 'success')
          }
        })
      }
    },
    getFeature(handle) {
      if (!this.isGettingFeature) return
      this.addLog('请按手指', 'info')
      Fp.getFeature(handle, (returnObj) => {
        const stateCode = returnObj.stateCode
        if (stateCode == Fp.RT_SUCCESS) {
          this.addLog(`特征大小: ${returnObj.featureLen}, 特征: ${returnObj.feature}`, 'success')
          this.feature = returnObj.feature
          // 验证指纹
          this.fingerprintVerify()
          Fp.closeDevice(handle, (returnObj) => {
            if (returnObj.retCode == Fp.RT_SUCCESS) {
              this.addLog('设备已关闭', 'success')
              this.isGettingFeature = false
              // 重新获取特征
              this.openDialog()
            }
          })
        } else if (stateCode == Fp.RT_FP_CANCEL) {
          this.addLog('获取特征任务已取消', 'warning')
          this.isGettingFeature = false
        } else {
          if (this.lastStateCode != stateCode) {
            this.lastStateCode = stateCode
            this.handleStateCode(stateCode)
          }

          Fp.sleep(200)
          this.getFeature(handle)
        }
      })
    },
    handleStateCode(stateCode) {
      switch (stateCode) {
        case Fp.RT_BAD_QUALITY:
          this.addLog('##指纹质量差，请重试', 'warning')
          this.text = '指纹质量差，请重试'
          break
        default:
          this.addLog(`状态码: ${stateCode}`, 'info')
      }
    },
    // 验证指纹
    fingerprintVerify() {
      this.$api.roleApi.fingerprintVerify({ feature: this.feature }).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.fingerprintVerifySuccess(this.feature)
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.content {
  margin: 20px 30px 40px;


  .collection {
    text-align: center;

    .text {
      margin-top: 20px;
      font-size: 16px;
      color: #333;
    }
  }
}

/deep/ .el-dialog__header {
  padding: 20px;
  border-bottom: 1px solid #D8D8D8;
}
</style>